import { getSafe } from "../util/storeHelper";
export const isTelemetryEnabled = (state) => getSafe(state, ["settings", "analytics", "enabled"], false);
